import { atom } from "recoil";
import { ATOM_SESSION_ID } from "../constants";

export const sessionIdAtom = atom<string>({
  key: ATOM_SESSION_ID,
  default: "",
});
